
import React from 'react'
import { Button } from '@mui/material';

import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const CustomOptions = ({
    type,
    width = "200px",
    selected,
    onClick,
    disabled = false,
  }) => {
    return (
      <Button
        size="small"
        variant="contained"
        endIcon={
          <CheckCircleIcon
            style={{
              color: selected ? "#00ba00" : "#d7d7d7",
              fontSize: "16px",
            }}
          />
        }
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          fontWeight: 400,
          fontSize: "11px",
          border: selected ? "0.1px solid #f6ffe6" : "0.1px solid #d7d7d7",
          backgroundColor: selected
            ? "#f6ffe6"
            : disabled
            ? "#f0f0f0"
            : "#ffffff",
          color: disabled ? "#a0a0a0" : "#333333",
          borderRadius: "3px",
          textTransform: "none",
          width: width,
          padding: "2px 10px",
          whiteSpace: "nowrap",
          cursor: disabled ? "not-allowed" : "pointer",
          opacity: disabled && !selected ? 0.6 : 1,
          margin: "4px 0",
          minHeight: "28px",
          boxShadow: "none",
          transition: "all 0.2s ease",
          "&:hover": {
            backgroundColor: selected
              ? "#f6ffe6"
              : disabled
              ? "#f0f0f0"
              : "#f8f8f8",
            boxShadow: "none",
          },
        }}
        onClick={disabled ? undefined : onClick}
        disableRipple
        disableElevation
      >
        <span style={{ flexGrow: 1, textAlign: "left", overflow: "hidden" }}>
          {type}
        </span>
      </Button>
    );
  };

export default CustomOptions